
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectsEditHeadline: {
    id: "ProjectsEdit.headline",
    defaultMessage: "Please edit your project:",
  },
});

export default MESSAGES;